import {
  AgGridFilter,
  CellStyleProtocol as CellStyleProtocol,
  RowStyleProtocol,
  ScientValueFormatter,
  ScientCellStyle,
} from "./components/agGridMapping"

export enum PositionSide {
  LONG = "long",
  SHORT = "short",
}

export enum PinnedPosition {
  LEFT = "left",
  RIGHT = "right",
}

export enum ScrollPosition {
  END = "end",
}

export enum OrderSide {
  BUY = "Buy",
  SELL = "Sell",
  BUY_COVER = "Buy Cover",
  SELL_SHORT = "Sell Short",
}

export enum ProviderType {
  BEACON = "beacon",
  ENFUSION = "enfusion",
}

export enum PortfolioDisplayTab {
  POSITIONS = "positions",
  ORDERS = "orders",
  RISKS = "risks",
  TRADING = "trading",
  FACTSHEET = "factsheet",
}

export type ScientTradingAccount = {
  id: number
  name: string
  is_default?: boolean
}

export type TradingBook = {
  id: number
  code: string
  trading_account_scients: ScientTradingAccount[]
  is_default?: boolean
  is_default_filter?: boolean
  default_filter_account_ids?: number[]
}

export type Column = {
  field: string
  filter?: AgGridFilter | boolean
  valueFormatter: ScientValueFormatter
  cellStyles: (ScientCellStyle | CellStyleProtocol)[]
  hide?: boolean
  headerTooltip?: string
  tooltipField?: string
  export_included?: boolean
  headerName?: string
  pinned?: PinnedPosition
}

/**
 * Enum for context menu items that matches the backend ContextMenuItem enum
 */
export enum ContextMenuItem {
  EXPORT = "export",
  CANCEL_ORDER = "cancel_order",
  REPLACE_ORDER = "replace_order",
  FORCE_LOCATE = "force_locate",
  /**
   * Separator for context menu items, only defined in the front
   */
  SEPARATOR = "separator",
}

export type Row = Record<string, string | number | null | undefined>

export type PinnedBottomRowStyle = {
  rowIndex: number
  rowStyle: RowStyleProtocol
}

export type PinnedBottomRow = {
  rowData: Row[]
  rowStyles: PinnedBottomRowStyle[]
}

/**
 * A mask is a row of a dataframe that has been masked.
 * It is used to highlight the rows that have been masked.
 */
export type Mask = {
  _idx: number
  [key: string]: string | number | null
}

export type DataframeData = {
  rows: Row[]
  columns: Column[]
  last_updated_at?: string
  pinnedBottomRows?: PinnedBottomRow
  context_menu_items?: ContextMenuItem[]
  row_styles?: RowStyleProtocol[]
  initialScrollPosition?: ScrollPosition
  initialScrollColumn?: string
  masks?: Record<string, Mask[]>
}

export type IAccountBookPairs = {
  account_id: number
  book_ids?: number[]
}[]
